import PropTypes from 'prop-types';
import React from 'react';
import Router from '@module/router';

import I18n from '@module/i18n';
import Assets from '@app/assets';

export default class AdvertContent extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    image: PropTypes.string,
    examplesLink: PropTypes.string,
    checklistItems: PropTypes.array,
  };

  static defaultProps = {
    checklistItems: [],
  };

  constructor(props) {
    super(props);

    this.onExamplesClick = this.onExamplesClick.bind(this);
  }

  makeChecklist() {
    const checklistItems = [
      <li key="checklistRequirement1">
        {I18n.t(
          'page.advertise.guidelines.advert_general_requirements.requirement_one'
        )}
      </li>,
      <li key="checklistRequirement2">
        {I18n.t(
          'page.advertise.guidelines.advert_general_requirements.requirement_two'
        )}
      </li>,
      <li key="checklistRequirement3">
        {I18n.t(
          'page.advertise.guidelines.advert_general_requirements.requirement_three'
        )}
      </li>,
      <li key="checklistRequirement4">
        {I18n.t(
          'page.advertise.guidelines.advert_general_requirements.requirement_four'
        )}
      </li>,
    ];

    this.props.checklistItems.forEach((item) =>
      checklistItems.push(
        <li key={`checklistRequirement${checklistItems.length + 1}`}>{item}</li>
      )
    );

    return checklistItems;
  }

  onExamplesClick() {
    const params = {};
    params['search'] =
      'tag=' +
      this.props.type.charAt(0).toUpperCase() +
      this.props.type.slice(1);
    Router.navigateTo('/advertise/gallery', false, params);
  }

  render() {
    return (
      <div>
        {this.props.image ? (
          <img
            key={`advert${this.props.type}Image`}
            src={Assets.lookup(this.props.image)}
          />
        ) : null}
        <a
          key={`advert${this.props.type}ExamplesLink`}
          onClick={this.onExamplesClick}
        >
          {I18n.t('page.advertise.guidelines.view_examples')}
        </a>
        <h6 key={`advert${this.props.type}ChecklistTitle`}>
          {I18n.t('page.advertise.guidelines.advert_delivery_checklist_title')}
        </h6>
        <ul key={`advert${this.props.type}Checklist`}>
          {this.makeChecklist()}
        </ul>
        <h6 key={`advert${this.props.type}ChecklistSubTitle`}>
          {I18n.t(
            'page.advertise.guidelines.advert_delivery_checklist_subtitle'
          )}
        </h6>
        <ul key={`advert${this.props.type}GeneralRequirements`}>
          <li>
            {I18n.t(
              'page.advertise.guidelines.advert_general_requirements.requirement_five'
            )}
          </li>
          <li
            dangerouslySetInnerHTML={{
              __html: I18n.t(
                'page.advertise.guidelines.advert_general_requirements.requirement_six'
              ),
            }}
          />
        </ul>
        <p key={`advert${this.props.type}LastRequirement`}>
          {I18n.t(
            'page.advertise.guidelines.advert_general_requirements.requirement_eight'
          )}
        </p>
      </div>
    );
  }
}
